<template>

     <swiper class="swiper" style="margin:5px;" :options="swiperOption">

        <swiper-slide v-for="(product, index) in productsObject" :key="product.id">

            <span class="gradient-border" :class="{ active: currentActiveProductId == product.id }" @click="navigateTo(index, product.id)">{{ product.name }}</span>

        </swiper-slide>

        <!-- <div class="swiper-button-prev" slot="button-prev"></div>

        <div class="swiper-button-next" slot="button-next"></div> -->

    </swiper>

</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

import 'swiper/swiper.scss';

export default {
    name: 'tags',
    data() {
        return {
            currentActiveProductId: null,
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 15,
                direction: 'horizontal',
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev'
                // },
            }
        }
    },
    props: ["products"],
    computed : {
        productsObject() {
            return this.products;
        },
    },
    components: {
        Swiper,
        SwiperSlide
    },
    methods: {
        navigateTo(value, productId) {

            this.currentActiveProductId = productId;

            this.$emit('navigateTo', value);
        }
    }
}
</script>

<style scoped>
    .swiper-slide {
        justify-content: center;
        display: flex;
        width: auto !important;
        margin: 3px;
    }

    .active {
        color: #212529;
        background-color: #f8f9fa !important;
    }

    .gradient-border {
        padding: 0 12px;
        font-weight: bold;
        line-height: 32px;
        cursor: pointer;
        background: #08050585;
        border-radius: 16px;
    }

    .gradient-border:after {
        content: '';
        position: absolute;
        top: calc(-1 * 2px);
        left: calc(-1 * 2px);
        height: calc(100% + 2px * 2);
        width: calc(100% + 2px * 2);
        background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
        border-radius: 16px;
        z-index: -1;
        animation: animatedgradient 3s ease alternate infinite;
        background-size: 300% 300%;
    }

    @keyframes animatedgradient {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }
</style>
